export const data =


{
    ammattitaitovaatimus: "Käyttää alan työmenetelmiä, -välineitä ja materiaaleja perushoidossa ja huolenpidossa, saattohoidossa ja lääkehoidossa ",

    lääkkeen_valinta: {
        teksti: '',
        ammattitaitovaatimus: ''
    },

    annostelu: {
        teksti: '',
        kriteeri_t1_a: 'tekee virheettömästi annoslaskut sekä yksikönmuunnokset',
        kriteeri_t1_b: 'käsittelee ja annostelee lääkkeet aseptisesti, virheettömästi ja turvallisesti',
        kriteeri_h3_a: 'tekee virheettömästi annoslaskut sekä yksikönmuunnokset',
        kriteeri_h3_b: 'käsittelee ja annostelee lääkkeet aseptisesti, virheettömästi ja turvallisesti',
        kriteeri_k5_a: 'tekee virheettömästi annoslaskut sekä yksikönmuunnokset',
        kriteeri_k5_b: 'käsittelee ja annostelee lääkkeet aseptisesti, virheettömästi ja turvallisesti',

    },
    aseptiikka: {
        teksti: '',
        kriteeri_t1: 'käsittelee ja annostelee lääkkeet aseptisesti, virheettömästi ja turvallisesti',
        kriteeri_h3: 'käsittelee ja annostelee lääkkeet aseptisesti, virheettömästi ja turvallisesti',
        kriteeri_k5: 'käsittelee ja annostelee lääkkeet aseptisesti, virheettömästi ja turvallisesti',
        palaute_aseptiikka_ok: 'Aseptiikka sinulla kunnossa',
        palaute_aseptiikka_ei_ok: 'Aseptiikkaa ei saa laiminlyödä ',
        palaute_jos_hanskat_unohtui: ''

    },

    pistopaikka:
    {

        teksti: 'Mihin kohtaan pistät insuliinin? Klikkaa kuvasta.',

        kriteeri_t1: 'Antaa lääkkeet luonnollista tietä injektiona ihon alle ja lihakseen sekä hengityksen kautta ohjeiden mukaan. ',
        kriteeri__h3: 'Antaa lääkkeet luonnollista tietä, injektiona ihon alle ja lihakseen ja hengitettynä ohjeiden mukaan. ',
        kriteeri__k5: 'Antaa lääkkeet luonnollista tietä, injektiona ihon alle ja lihakseen ja hengitettynä ohjeiden ja tilanteen mukaisesti. ',

        palaute_pistopaikka_ok: 'Valitsit hyvän pistopaikan',
        palaute_pistopaikka_ei_ok: 'Valitsemasi alue ei sovellu insuliinin pistämiseen',
        palaute_jos_kasvot: 'Not the face!',
        palaute_jos_genitaalit: 'Tokikaan emme pistä genitaaleihin insuliinia ',
        palaute_jos_ohi: 'Oliko sinulla varmasti silmät auki?'

    },



    pistosyvyys:
    {

        teksti: 'Miten syvälle neula pitää työntää?',
        kriteeri_t1: 'Antaa lääkkeet luonnollista tietä injektiona ihon alle ja lihakseen sekä hengityksen kautta ohjeiden mukaan. ',
        kriteeri__h3: 'Antaa lääkkeet luonnollista tietä, injektiona ihon alle ja lihakseen ja hengitettynä ohjeiden mukaan. ',
        kriteeri__k5: 'Antaa lääkkeet luonnollista tietä, injektiona ihon alle ja lihakseen ja hengitettynä ohjeiden ja tilanteen mukaisesti. ',
        palaute_pistosyvyys_ok: 'Osasit pistää oikeaoppisesti ihonalaiskudokseen (SC)',
        palaute_pistosyvyys_ei_ok: 'Pistosyvyys väärä - tarkoitus on osua subcutaanikudokseen ',
        palaute_jos_liian_matala: 'Käyttämälläsi pistosyvyydellä ei  vielä päästä ihonalaiskudokseen ',
        palaute_jos_liian_syvä: 'Pisto osui varmaankin lihakseen - vaikutus on tällöin liian nopea.'



    },


    palaute_osaamistaso0: 'Valitettavasti tämä meni pieleen. Lääkehoito edellyttää virheettömyyttä. (hyl)',
    palaute_osaamistaso1: '(T1)',
    palaute_osaamistaso2: '(T2)',
    palaute_osaamistaso3: '(T2)',
    palaute_osaamistaso4: '(T2)',
    palaute_osaamistaso5: '(T2)',


};


